import type { Building } from "@senciamatch/shared/models/building";

import { v7 as uuidv7 } from "uuid";

interface BuildingWithCompany extends Building {
  companyName: string;
}

interface Props {
  buildings: BuildingWithCompany[];
  onSelect: (building: Building) => void;
}

export const BuildingTable: React.FC<Props> = ({ buildings, onSelect }) => {
  return (
    <div className="overflow-y-auto flex-grow px-10 my-10">
      <table className="min-w-full">
        <thead className="sticky top-0 bg-gray-100">
          <tr className="bg-gray-100">
            <th className="p-2 text-left border border-gray-200">物件番号</th>
            <th className="p-2 text-left border border-gray-200">物件名</th>
            <th className="p-2 text-left border border-gray-200">会社名</th>
            <th className="p-2 text-left border border-gray-200">住所</th>
            <th className="p-2 text-left border border-gray-200">その他情報</th>
            <th className="p-2 text-left border border-gray-200">-</th>
          </tr>
        </thead>
        <tbody>
          {buildings.map((building) => (
            <tr key={uuidv7()}>
              <td className="p-2 text-left border border-gray-200">{building.casNaviId}</td>
              <td className="p-2 text-left border border-gray-200">{building.name}</td>
              <td className="p-2 text-left border border-gray-200">{building.companyName}</td>
              <td className="p-2 text-left border border-gray-200">
                {building.postalCode}
                <br />
                {building.address}
              </td>
              <td className="p-2 text-left border border-gray-200">
                <p>
                  スーツ着用: {building.isSuitsNeeded ? "必要" : "不要"}
                  <br />
                  清掃: {building.mustCleaning ? "必要" : "不要"}
                  <br />
                  男性専用: {building.menOnly ? "専用" : "共用"}
                  <br />
                  女性専用: {building.womenOnly ? "専用" : "共用"}
                  <br />
                  防災センター要員: {building.needDisasterCenter ? "必要" : "不要"}
                </p>
              </td>
              <td className="p-2 text-left border border-gray-200">
                <button type="button" className="text-primary-700" onClick={() => onSelect(building)}>
                  選択
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
